import React, { useState, useEffect } from "react";
import firebase from "firebase/app";
import "firebase/firestore";
import { Context } from "../backend/context";

import { Link, withRouter } from "react-router-dom";
import { Redirect } from "react-router";
import BotOrderDetails from "./botOrderDetails";

const CoinGecko = require("coingecko-api");
const CoinGeckoClient = new CoinGecko();

function Bot(props) {
  const {
    bots,
    isLoggedIn,
    user,
    isProUser,
    isProPlusUser,
    uid,
    alert,
    isRestricted,
    binance_api_key,
    kucoin_api_key,
  } = React.useContext(Context);
  const [bot, setBot] = useState(null);

  const [type, setType] = useState("BUY");
  const [dcaOrGrid, setDcaOrGrid] = useState("GRID");
  const [market, setMarket] = useState("btc_usdc");
  const [strategy, setStrategy] = useState("makerBot");
  const [interval, setInterval] = useState("5m");
  const [limit, setLimit] = useState(14);
  const [arbitragePres, setArbitragePres] = useState(0.1);
  const [threshold, setThreshold] = useState(30);
  const [orderSize, setOrderSize] = useState(0);
  const [holdAmount, setHoldAmount] = useState(0);
  const [quoteAssetBinance, setQuoteAssetBinance] = useState("usdc");
  const [multiplier, setMultiplier] = useState(1);
  const [marketData, setMarketData] = useState({
    minOrder: 15,
    quoteAsset: "usdc",
    maxOrder: 100000,
    baseAsset: "btc",
  });
  const [takeProfit, setTakeProfit] = useState(0.3);
  const [maxExtraOrders, setMaxExOrders] = useState(3);
  const [activeExtraOrders, setActiveExOrders] = useState(1);
  const [stepOfExtraOrder, setStepExOrder] = useState(2);
  const [isEditing, setEditing] = useState(false);
  const [stopLoss, setStopLoss] = useState(5);
  const [isStopLossSet, setIsStopLossSet] = useState(false);
  const [maxOrderSize, setMaxOrderSize] = useState(100000);
  const [name, setName] = useState("");

  const [maxBuy, setmaxBuy] = useState(1000);
  const [isTaker, setisTaker] = useState(true);
  const [takerArbitragePres, settakerArbitragePres] = useState(0.13);
  const [sellArbitragePres, setSellArbitragePres] = useState(0.07);
  const [sellTakerArbitragePres, setSellTakerArbitragePres] = useState(0.1);
  const [isSellAfterBuy, setSellAfterBuy] = useState(false);

  const [currencyPrice, setCurrencyPrice] = useState(0);

  useEffect(() => {
    var id = props.match.params.id;
    var isAva = false;
    bots.forEach((element) => {
      if (element.id === id) {
        // console.log(element);
        setBot(element);
        setType(element.type);
        setName(
          element.name && element.name.length > 0
            ? element.name
            : element.displayId
        );
        setMarket(element.market);
        setDcaOrGrid(element.dcaOrGrid);
        setStrategy(element.strategy.name);
        setInterval(element.strategy.interval);
        setLimit(element.strategy.limit);
        setThreshold(element.strategy.threshold);
        setArbitragePres(
          element.strategy.arbitragePres ? element.strategy.arbitragePres : 0.1
        );
        setSellTakerArbitragePres(
          element.strategy.sellTakerArbitragePres
            ? element.strategy.sellTakerArbitragePres
            : element.strategy.takerArb
            ? element.strategy.takerArb
            : 0.2
        );
        setSellArbitragePres(
          element.strategy.sellArbitragePres
            ? element.strategy.sellArbitragePres
            : element.strategy.arbitragePres
            ? element.strategy.arbitragePres
            : 0.1
        );
        setSellAfterBuy(
          element.strategy.isSellAfterBuy
            ? element.strategy.isSellAfterBuy
            : false
        );
        setHoldAmount(element.holdAmount ? element.holdAmount : 0);
        setQuoteAssetBinance(
          element.quoteAssetBinance ? element.quoteAssetBinance : "usdc"
        );
        setOrderSize(element.orderSize);
        setTakeProfit(element.takeProfit);
        setMaxExOrders(element.maxExtraOrders);
        setActiveExOrders(element.activeExtraOrders);
        setStepExOrder(element.stepOfExtraOrder);
        setStopLoss(element.stopLoss);
        setIsStopLossSet(element.isStopLossSet);
        setMultiplier(element.multiplier ? element.multiplier : 1);

        settakerArbitragePres(
          element.strategy.takerArb ? element.strategy.takerArb : 0.2
        );
        setmaxBuy(element.strategy.maxBuy ? element.strategy.maxBuy : 1000);
        setisTaker(element.strategy.isTaker ? element.strategy.isTaker : true);

        isAva = true;
        return;
      }
    });
    if (!isAva) {
      setBot(null);
    }
  }, [bots, props]);

  useEffect(() => {
    if (strategy === "BINANCE-ARB" || strategy === "KUCOIN-ARB") {
      setMaxOrderSize(marketData.maxOrder);
    } else {
      setMaxOrderSize(100000);
    }
  }, [strategy, marketData]);

  var exdata = [
    {
      symbolB: "ETH/USDC",
      symbol: "eth_usdc",
      tradingAsset: "base",
      baseAsset: "eth",
      quoteAsset: "usdc",
      tickDigits: 100,
      minOrder: 15,
      maxOrder: 2000,
      coingeckoId: "ethereum",
      coingeckoConvertedAsset: "usd",
    },

    {
      symbolB: "BTC/USDC",
      symbol: "btc_usdc",
      tradingAsset: "base",
      baseAsset: "btc",
      quoteAsset: "usdc",
      tickDigits: 10,
      minOrder: 15,
      maxOrder: 2000,
      coingeckoId: "bitcoin",
      coingeckoConvertedAsset: "usd",
    },
    {
      symbolB: "NEO/USDC",
      symbol: "neo_usdc",
      tradingAsset: "base",
      baseAsset: "neo",
      quoteAsset: "usdc",
      tickDigits: 100,
      minOrder: 20,
      maxOrder: 2000,
      coingeckoId: "neo",
      coingeckoConvertedAsset: "usd",
    },
    {
      symbolB: "ETH/BTC",
      symbol: "eth_btc",
      tradingAsset: "base",
      baseAsset: "eth",
      quoteAsset: "btc",
      tickDigits: 10000000,
      minOrder: 0.0011,
      maxOrder: 0.3,
      coingeckoId: "ethereum",
      coingeckoConvertedAsset: "btc",
    },

    {
      symbolB: "LINK/USDC",
      symbol: "link_usdc",
      tradingAsset: "base",
      baseAsset: "link",
      quoteAsset: "usdc",
      tickDigits: 10000,
      minOrder: 30,
      maxOrder: 2000,
      coingeckoId: "chainlink",
      coingeckoConvertedAsset: "usd",
    },
    {
      symbolB: "GUNTHY/BTC",
      symbol: "gunthy_btc",
      tradingAsset: "base",
      baseAsset: "gunthy",
      quoteAsset: "btc",
      tickDigits: 100000000,
      minOrder: 0.0011,
      maxOrder: 0.03,
      coingeckoId: "gunthy",
      coingeckoConvertedAsset: "btc",
    },
    {
      symbolB: "NOIA/BTC",
      symbol: "noia_btc",
      tradingAsset: "base",
      baseAsset: "noia",
      quoteAsset: "btc",
      tickDigits: 100000000,
      minOrder: 0.0011,
      maxOrder: 0.3,
      coingeckoId: "noia-network",
      coingeckoConvertedAsset: "btc",
    },
    {
      symbolB: "NOIA/USDC",
      symbol: "noia_usdc",
      tradingAsset: "base",
      baseAsset: "noia",
      quoteAsset: "usdc",
      tickDigits: 100000,
      minOrder: 15,
      maxOrder: 3000,
      coingeckoId: "noia-network",
      coingeckoConvertedAsset: "usd",
    },
    {
      symbolB: "BAT/USDC",
      symbol: "bat_usdc",
      tradingAsset: "base",
      baseAsset: "bat",
      quoteAsset: "usdc",
      tickDigits: 10000,
      minOrder: 20,
      maxOrder: 300,
      coingeckoId: "basic-attention-token",
      coingeckoConvertedAsset: "usd",
    },
    {
      symbolB: "GAS/NEO",
      symbol: "gas_neo",
      tradingAsset: "base",
      baseAsset: "gas",
      quoteAsset: "neo",
      tickDigits: 1000,
      minOrder: 0.51,
      maxOrder: 100,
      coingeckoId: "gas",
      coingeckoConvertedAsset: "usd",
    },
  ];

  const getSymbolData = (symbol) => {
    var symbolD = {};
    exdata.forEach((element) => {
      if (element.symbol === symbol) {
        symbolD = element;
        return;
      }
    });
    return symbolD;
  };

  const setIsEditing = (va) => {
    if (!va) {
      setType(bot.type);
      setName(bot.name && bot.name.length > 0 ? bot.name : bot.displayId);
      setMarket(bot.market);
      setStrategy(bot.strategy.name);
      setDcaOrGrid(bot.dcaOrGrid);
      setInterval(bot.strategy.interval);
      setLimit(bot.strategy.limit);
      setArbitragePres(
        bot.strategy.arbitragePres ? bot.strategy.arbitragePres : 0.1
      );
      setHoldAmount(bot.holdAmount ? bot.holdAmount : 0);
      setQuoteAssetBinance(
        bot.quoteAssetBinance ? bot.quoteAssetBinance : "usdc"
      );
      setSellTakerArbitragePres(
        bot.strategy.sellTakerArbitragePres
          ? bot.strategy.sellTakerArbitragePres
          : bot.strategy.takerArb
          ? bot.strategy.takerArb
          : 0.2
      );
      setSellArbitragePres(
        bot.strategy.sellArbitragePres
          ? bot.strategy.sellArbitragePres
          : bot.strategy.arbitragePres
          ? bot.strategy.arbitragePres
          : 0.1
      );
      setSellAfterBuy(
        bot.strategy.isSellAfterBuy ? bot.strategy.isSellAfterBuy : false
      );
      setThreshold(bot.strategy.threshold);
      setMultiplier(bot.multiplier ? bot.multiplier : 1);
      setOrderSize(bot.orderSize);
      setTakeProfit(bot.takeProfit);
      setMaxExOrders(bot.maxExtraOrders);
      setActiveExOrders(bot.activeExtraOrders);
      setStepExOrder(bot.stepOfExtraOrder);
      setStopLoss(bot.stopLoss);
      setIsStopLossSet(bot.isStopLossSet);
      settakerArbitragePres(
        bot.strategy.takerArb ? bot.strategy.takerArb : 0.2
      );
      setmaxBuy(bot.strategy.maxBuy ? bot.strategy.maxBuy : 1000);
      setisTaker(bot.strategy.isTaker ? bot.strategy.isTaker : true);
      setEditing(false);
    }
  };

  const getTotalCapital = () => {
    var total = parseFloat(orderSize);
    // console.log(maxExtraOrders);
    for (let index = 1; index < parseFloat(maxExtraOrders) + 1; index++) {
      total += parseFloat(orderSize) * parseFloat(multiplier) ** index;
      // console.log(parseFloat(orderSize) * parseFloat(multiplier) ** index);
    }
    if (type === "BUY" && marketData.quoteAsset === "usdc") {
      total = parseFloat(total.toFixed(2));
    } else if (type === "BUY") {
      total = parseFloat(total.toFixed(6));
    } else {
      total = parseFloat((total / currencyPrice).toFixed(6));
    }

    return total;
  };

  useEffect(() => {
    const data = getSymbolData(market);
    setMarketData(data);
    if (
      market === "gunthy_btc" ||
      ((market === "noia_btc" ||
        market === "noia_usdc" ||
        market === "gas_neo") &&
        !(strategy === "MARKET-MAKER" || strategy === "KUCOIN-ARB"))
    ) {
      if (strategy === "MAKER-TAKER") {
        setStrategy("MAKER-TAKER");
      } else {
        setStrategy("makerBot");
      }
    }
    if (bot !== null) {
      getPrices(data);
    }
    if (strategy === "EMA-MA-CROSSOVER") {
      setMaxExOrders(0);
    }
  }, [market, strategy, bot]);

  const getPrices = async (data) => {
    let coinData = await CoinGeckoClient.coins.fetchTickers(data.coingeckoId, {
      order: CoinGecko.ORDER.VOLUME_DESC,
    });

    setCurrencyPrice(
      coinData.data.tickers[0].converted_last[data.coingeckoConvertedAsset]
    );
  };

  const handleSubmit = (e) => {
    // console.log("handle submit");
    e.preventDefault();

    let data = {
      name: name,
      type: type,
      market: market,
      dcaOrGrid: dcaOrGrid,
      strategy: {
        name: strategy,
        interval: interval,
        limit: parseInt(limit),
        threshold: parseFloat(threshold),
        arbitragePres: parseFloat(arbitragePres),
        isTaker: isTaker,
        takerArb: parseFloat(takerArbitragePres),
        maxBuy: parseFloat(maxBuy),
        sellTakerArbitragePres: parseFloat(sellTakerArbitragePres),
        sellArbitragePres: parseFloat(sellArbitragePres),
        isSellAfterBuy: isSellAfterBuy,
      },
      orderSize: parseFloat(orderSize),
      holdAmount: parseFloat(holdAmount),
      quoteAssetBinance: quoteAssetBinance,
      updatedAt: Date.now(),
      takeProfit: parseFloat(takeProfit),
      maxExtraOrders: parseFloat(maxExtraOrders),
      activeExtraOrders: parseFloat(activeExtraOrders),
      stepOfExtraOrder: parseFloat(stepOfExtraOrder),
      stopLoss: parseFloat(stopLoss),
      multiplier: parseFloat(multiplier),
      isStopLossSet: isStopLossSet,
      uid: bot.uid,
      isRunning: bot.isRunning,
      isDeleted: bot.isDeleted,
      isPending: bot.isPending,
      processID: bot.processID,
      stopAfterDealComplete: bot.stopAfterDealComplete
        ? bot.stopAfterDealComplete
        : false,
    };
    firebase
      .firestore()
      .collection("bots")
      .doc(props.match.params.id)
      .update(data)
      .catch((err) => {
        console.log(err);
      });
    setEditing(false);
  };

  const stopBot = () => {
    if (window.confirm(`Stop bot ${bot.displayId} ?`)) {
      var docu = firebase
        .firestore()
        .collection("bots")
        .doc(props.match.params.id);
      docu.update({ isRunning: false });
    }
  };
  const stopBotAfterDealComplete = () => {
    if (window.confirm(`Stop bot after deal complete ${bot.displayId} ?`)) {
      var docu = firebase
        .firestore()
        .collection("bots")
        .doc(props.match.params.id);
      docu.update({ stopAfterDealComplete: true });
    }
  };
  const startBot = () => {
    if (window.confirm(`Start bot ${bot.displayId} ?`)) {
      var docu = firebase
        .firestore()
        .collection("bots")
        .doc(props.match.params.id);
      docu.update({ isPending: true });
      firebase
        .firestore()
        .collection("pendingBots")
        .doc(props.match.params.id)
        .set({ ...bot, isPending: true })
        .catch((err) => {
          console.log(err);
        });
      props.history.push("/account");
    }
  };
  const deleteBot = () => {
    if (window.confirm(`Delete bot ${bot.displayId} ?`)) {
      var docu = firebase
        .firestore()
        .collection("bots")
        .doc(props.match.params.id);
      docu.update({ isDeleted: true, isRunning: false });

      firebase
        .database()
        .ref(`pendingOrders/${uid}/${props.match.params.id}`)
        .remove();
      firebase
        .database()
        .ref(`filledOrders/${uid}/${props.match.params.id}`)
        .remove();
      firebase
        .database()
        .ref(`cancelledOrders/${uid}/${props.match.params.id}`)
        .remove();
      // console.log(props.match.params.id, "deleted");

      props.history.push("/account");
    }
  };
  const cancelPendingOrders = () => {
    if (
      window.confirm(
        `Do you want to cancel all pending orders in bot ${bot.displayId} ?`
      )
    ) {
      var docu = firebase
        .firestore()
        .collection("bots")
        .doc(props.match.params.id);
      docu.update({ cancelPendingOrders: true });
    }
  };
  const cancelPendingOrdersAndStop = () => {
    if (
      window.confirm(
        `Do you want to cancel all pending orders and stop the bot ${bot.displayId} ?`
      )
    ) {
      var docu = firebase
        .firestore()
        .collection("bots")
        .doc(props.match.params.id);
      docu.update({ cancelPendingOrders: true, isRunning: false });
    }
  };

  return (
    <div className="py-5 container-fluid text-left badge-dark">
      {!isLoggedIn || !user ? <Redirect to="/" /> : null}
      {alert.isAvailable && (
        <div className="row">
          <div
            className={
              "col-11  col-sm-6 text-center alert m-auto alert-" + alert.type
            }
          >
            {alert.msg}
          </div>
        </div>
      )}
      {bot ? (
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 m-auto">
              <div className="row">
                <div className="col-sm-6 mt-3 border border-black rounded-lg badge-dark ">
                  <div className="row mt-3">
                    <div className="col-12 h5 text-center m-auto">
                      Bot Settings
                    </div>
                  </div>
                  <div className="row m-1">
                    <div className="col-12">
                      <form onSubmit={handleSubmit}>
                        <div className="form-group row mt-3 ">
                          <label className="col-sm-5 col-form-label">
                            Name
                          </label>
                          <div className="col-sm-6">
                            <input
                              disabled={!isEditing}
                              onChange={(e) => {
                                setName(e.target.value);
                              }}
                              type="text"
                              className="form-control"
                              value={name}
                            />
                          </div>
                        </div>
                        {strategy !== "MARKET-MAKER" &&
                          strategy !== "MARKET-MAKER-RSI" &&
                          strategy !== "EMA-MA-CROSSOVER" && (
                            <div className="form-group row mt-3 ">
                              <label className="col-sm-5 col-form-label">
                                Trend
                              </label>
                              <div className="col-sm-6">
                                <select
                                  required
                                  disabled
                                  onChange={(e) => {
                                    setType(e.target.value);
                                  }}
                                  className="custom-select mr-sm-2"
                                  defaultValue={type}
                                >
                                  <option value="BUY">UP (BUY)</option>
                                  <option value="SELL">Down (SELL)</option>
                                </select>
                              </div>
                            </div>
                          )}
                        <div className="form-group row">
                          <label className="col-sm-5 col-form-label">
                            Market
                          </label>
                          <div className="col-sm-6">
                            <select
                              disabled
                              required
                              className="custom-select mr-sm-2"
                              defaultValue={market}
                            >
                              {exdata.map((item, key) => (
                                <option key={key} value={item.symbol}>
                                  {item.symbolB}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <div className="form-group row">
                          <label className=" col-sm-5 col-form-label">
                            {strategy === "BINANCE-ARB" ||
                            strategy === "KUCOIN-ARB" ||
                            strategy === "MARKET-MAKER" ||
                            strategy === "MARKET-MAKER-RSI" ||
                            strategy === "EMA-MA-CROSSOVER"
                              ? "Max "
                              : ""}{" "}
                            Order Size ({marketData.quoteAsset.toUpperCase()})
                          </label>
                          <div className="col-sm-6">
                            <input
                              onChange={(e) => {
                                setOrderSize(e.target.value);
                              }}
                              disabled={!isEditing}
                              required
                              type="number"
                              step="0.0001"
                              className="form-control"
                              min={marketData.minOrder}
                              value={orderSize}
                              max={maxOrderSize}
                            />
                          </div>
                        </div>
                        <div className="form-group row">
                          <label className="col-sm-5 col-form-label">
                            {strategy === "MARKET-MAKER" ||
                            strategy === "MARKET-MAKER-RSI" ||
                            strategy === "EMA-MA-CROSSOVER"
                              ? "Max "
                              : ""}{" "}
                            Take Profit (%){" "}
                          </label>
                          <div className="col-sm-6">
                            <input
                              disabled={!isEditing}
                              required
                              onChange={(e) => {
                                setTakeProfit(e.target.value);
                              }}
                              type="number"
                              step="0.0001"
                              className="form-control"
                              min="0"
                              value={takeProfit}
                            />
                          </div>
                        </div>
                        <div className="form-group row">
                          <div className="col-12 border border-black rounded-lg pt-4 componentWrapper">
                            <div className="header">Strategy Settings</div>
                            <div className="form-group row">
                              <label className="col-sm-5 col-form-label">
                                Strategy
                              </label>
                              <div className="col-sm-6">
                                <select
                                  disabled={bot.isRunning || !isEditing}
                                  required
                                  onChange={(e) => {
                                    setStrategy(e.target.value);
                                  }}
                                  className="custom-select mr-sm-2"
                                  defaultValue={strategy}
                                >
                                  {!(market === "gunthy_btc") && ( // (isProUser || isProPlusUser) &&
                                    <option value="MARKET-MAKER">
                                      Market Maker
                                    </option>
                                  )}
                                  <option value="makerBot">Maker </option>

                                  <option value="MAKER-TAKER">
                                    Maker - Taker
                                  </option>

                                  {!(
                                    market === "gunthy_btc" ||
                                    market === "noia_btc" ||
                                    market === "noia_usdc" ||
                                    market === "gas_neo"
                                  ) && (
                                    <React.Fragment>
                                      <option value="MARKET-MAKER-RSI">
                                        Market Maker RSI
                                      </option>
                                      <option value="EMA-MA-CROSSOVER">
                                        EMA-MA-Crossover
                                      </option>
                                      <option value="bband">
                                        Bollinger Bands
                                      </option>
                                      <option value="RSI">RSI</option>
                                      <option value="MAKER-RSI">
                                        Maker - RSI
                                      </option>
                                      <option value="MAKER-ARB">
                                        Maker - Arbitrage
                                      </option>
                                      <option value="MAKER-RSI-ARB">
                                        Maker-RSI-Arbitrage
                                      </option>
                                      <option value="TAKER-ARB">
                                        Taker - Arbitrage
                                      </option>
                                    </React.Fragment>
                                  )}
                                  {binance_api_key.length > 0 &&
                                    !(
                                      market === "gunthy_btc" ||
                                      market === "noia_btc" ||
                                      market === "noia_usdc" ||
                                      market === "gas_neo"
                                    ) && (
                                      <option value="BINANCE-ARB">
                                        Binance - Arbitrage
                                      </option>
                                    )}
                                  {kucoin_api_key.length > 0 &&
                                    !(market === "gunthy_btc") && (
                                      <option value="KUCOIN-ARB">
                                        Kucoin - Arbitrage
                                      </option>
                                    )}
                                </select>
                              </div>
                            </div>
                            {(strategy === "bband" ||
                              strategy === "RSI" ||
                              strategy === "MAKER-RSI" ||
                              strategy === "MAKER-RSI-ARB" ||
                              strategy === "EMA-MA-CROSSOVER") && (
                              <div>
                                <div className="form-group row ">
                                  <label className=" offset-1 col-sm-4 col-form-label">
                                    Interval
                                  </label>
                                  <div className="col-6">
                                    <select
                                      disabled={bot.isRunning || !isEditing}
                                      defaultValue={interval}
                                      required
                                      onChange={(e) => {
                                        setInterval(e.target.value);
                                      }}
                                      className="custom-select mr-sm-2"
                                    >
                                      <option value="1m">1m</option>
                                      <option value="3m">3m</option>
                                      <option value="5m">5m</option>
                                      <option value="15m">15m</option>
                                      <option value="30m">30m</option>
                                      <option value="1h">1h</option>
                                      <option value="2h">2h</option>
                                      <option value="4h">4h</option>
                                      <option value="6h">6h</option>
                                    </select>
                                  </div>
                                </div>{" "}
                                <div className="form-group row  ">
                                  <label className="offset-1 col-sm-4 col-form-label">
                                    Limit
                                  </label>
                                  <div className="col-6">
                                    <input
                                      disabled={bot.isRunning || !isEditing}
                                      required
                                      onChange={(e) => {
                                        setLimit(e.target.value);
                                      }}
                                      type="number"
                                      className="form-control"
                                      value={limit}
                                      min="0"
                                    />
                                  </div>
                                </div>
                                {(strategy === "RSI" ||
                                  strategy === "MAKER-RSI" ||
                                  strategy === "MAKER-RSI-ARB") && (
                                  <div className="form-group row  ">
                                    <label className="offset-1 col-sm-4 col-form-label">
                                      Threshold
                                    </label>
                                    <div className="col-6">
                                      <input
                                        disabled={!isEditing}
                                        required
                                        onChange={(e) => {
                                          setThreshold(e.target.value);
                                        }}
                                        type="number"
                                        className="form-control"
                                        value={threshold}
                                        min="5"
                                        step="0.01"
                                        max="45"
                                      />
                                    </div>
                                  </div>
                                )}
                              </div>
                            )}
                            {(strategy === "TAKER-ARB" ||
                              strategy === "MAKER-ARB" ||
                              strategy === "MAKER-RSI-ARB") && (
                              <div className="form-group row  ">
                                <label className="offset-1 col-sm-4 col-form-label">
                                  Arbitrage Percentage (%){" "}
                                </label>
                                <div className="col-6">
                                  <input
                                    disabled={!isEditing}
                                    onChange={(e) => {
                                      setArbitragePres(e.target.value);
                                    }}
                                    type="number"
                                    className="form-control"
                                    step="0.0001"
                                    value={arbitragePres}
                                    min="0"
                                    max="100"
                                  />
                                </div>
                              </div>
                            )}{" "}
                            {(strategy === "BINANCE-ARB" ||
                              strategy === "KUCOIN-ARB") && (
                              <div className="form-group row">
                                <label className=" col-sm-5 col-form-label">
                                  Hold amount (
                                  {marketData.quoteAsset.toUpperCase()}){" "}
                                </label>
                                <div className="col-sm-6">
                                  <input
                                    onChange={(e) => {
                                      setHoldAmount(e.target.value);
                                    }}
                                    disabled={!isEditing}
                                    type="number"
                                    className="form-control"
                                    value={holdAmount}
                                    min="0"
                                  />
                                </div>
                              </div>
                            )}
                            {(strategy === "BINANCE-ARB" ||
                              strategy === "KUCOIN-ARB") &&
                              (market === "eth_usdc" ||
                                market === "btc_usdc") && (
                                <div className="form-group row">
                                  <label className=" col-sm-5 col-form-label">
                                    {strategy === "BINANCE-ARB"
                                      ? "Binance"
                                      : "Kucoin"}{" "}
                                    USD asset
                                  </label>
                                  <div className="col-sm-6">
                                    <select
                                      required
                                      disabled={bot.isRunning || !isEditing}
                                      onChange={(e) => {
                                        setQuoteAssetBinance(e.target.value);
                                      }}
                                      className="custom-select mr-sm-2"
                                      defaultValue={quoteAssetBinance}
                                    >
                                      <option value="usdc">USDC</option>
                                      <option value="usdt">USDT</option>
                                    </select>
                                  </div>
                                </div>
                              )}
                            {strategy === "MARKET-MAKER" && (
                              <React.Fragment>
                                <div className="form-group row">
                                  <label className="offset-1 col-6 text-left col-form-label tooltipMy ">
                                    Max {marketData.baseAsset.toUpperCase()} Buy
                                    ({marketData.quoteAsset.toUpperCase()})
                                  </label>
                                  <div className="col-5 ">
                                    <input
                                      required
                                      disabled={!isEditing}
                                      onChange={(e) => {
                                        setmaxBuy(e.target.value);
                                      }}
                                      step="0.0001"
                                      type="number"
                                      className="form-control"
                                      value={maxBuy}
                                      min="0"
                                    />
                                  </div>
                                </div>
                                <div className="form-group row">
                                  <label className="offset-1 col-6 text-left col-form-label tooltipMy ">
                                    Sell Only Buys
                                  </label>
                                  <div className="col-3 form-check p-2 pr-3 m-auto text-left">
                                    <input
                                      type="checkbox"
                                      className="pr-3 mr-3 "
                                      // style={{ fontSize: "1.5rem" }}

                                      disabled={!isEditing}
                                      checked={isSellAfterBuy}
                                      onChange={(e) => {
                                        setSellAfterBuy(e.target.checked);
                                      }}
                                    />
                                  </div>
                                </div>
                                <div className="form-group row">
                                  <label className="offset-1 col-6 text-left col-form-label  ">
                                    Buy Arbitrage Percentage Maker (%)
                                  </label>
                                  <div className="col-5 ">
                                    <input
                                      required
                                      disabled={!isEditing}
                                      onChange={(e) => {
                                        setArbitragePres(e.target.value);
                                      }}
                                      type="number"
                                      className="form-control"
                                      step="0.0001"
                                      value={arbitragePres}
                                      min="-100"
                                      max="100"
                                    />
                                  </div>
                                </div>
                                <div className="form-group row">
                                  <label className="offset-1 col-6 text-left col-form-label  ">
                                    Buy Arbitrage Percentage Taker (%)
                                  </label>
                                  <div className="col-5 ">
                                    <input
                                      required
                                      disabled={!isEditing}
                                      onChange={(e) => {
                                        settakerArbitragePres(e.target.value);
                                      }}
                                      type="number"
                                      className="form-control"
                                      step="0.0001"
                                      value={takerArbitragePres}
                                      min="-100"
                                      max="100"
                                    />
                                  </div>
                                </div>
                                <div className="form-group row">
                                  <label className="offset-1 col-6 text-left col-form-label  ">
                                    Sell Arbitrage Percentage Maker (%)
                                  </label>
                                  <div className="col-5 ">
                                    <input
                                      required
                                      disabled={!isEditing}
                                      onChange={(e) => {
                                        setSellArbitragePres(e.target.value);
                                      }}
                                      type="number"
                                      className="form-control"
                                      step="0.0001"
                                      value={sellArbitragePres}
                                      min="-100"
                                      max="100"
                                    />
                                  </div>
                                </div>
                                <div className="form-group row">
                                  <label className="offset-1 col-6 text-left col-form-label  ">
                                    Sell Arbitrage Percentage Taker (%)
                                  </label>
                                  <div className="col-5 ">
                                    <input
                                      required
                                      disabled={!isEditing}
                                      onChange={(e) => {
                                        setSellTakerArbitragePres(
                                          e.target.value
                                        );
                                      }}
                                      type="number"
                                      className="form-control"
                                      step="0.0001"
                                      value={sellTakerArbitragePres}
                                      min="-100"
                                      max="100"
                                    />
                                  </div>
                                </div>
                              </React.Fragment>
                            )}
                            {strategy === "MARKET-MAKER-RSI" && (
                              <React.Fragment>
                                <div className="form-group row">
                                  <label className="offset-1 col-6 text-left col-form-label tooltipMy ">
                                    Max {marketData.baseAsset.toUpperCase()} Buy
                                    ({marketData.quoteAsset.toUpperCase()})
                                  </label>
                                  <div className="col-5 ">
                                    <input
                                      required
                                      disabled={!isEditing}
                                      onChange={(e) => {
                                        setmaxBuy(e.target.value);
                                      }}
                                      step="0.0001"
                                      type="number"
                                      className="form-control"
                                      value={maxBuy}
                                      min="0"
                                    />
                                  </div>
                                </div>
                                <div className="form-group row">
                                  <label className="offset-1 col-6 text-left col-form-label tooltipMy ">
                                    Sell Only Buys
                                  </label>
                                  <div className="col-3 form-check p-2 pr-3 m-auto text-left">
                                    <input
                                      type="checkbox"
                                      className="pr-3 mr-3 "
                                      // style={{ fontSize: "1.5rem" }}

                                      disabled={!isEditing}
                                      checked={isSellAfterBuy}
                                      onChange={(e) => {
                                        setSellAfterBuy(e.target.checked);
                                      }}
                                    />
                                  </div>
                                </div>
                              </React.Fragment>
                            )}
                            {strategy === "EMA-MA-CROSSOVER" && (
                              <div className="form-group row">
                                <label className="offset-1 col-6 text-left col-form-label tooltipMy ">
                                  Sell Only Buys
                                </label>
                                <div className="col-3 form-check p-2 pr-3 m-auto text-left">
                                  <input
                                    type="checkbox"
                                    className="pr-3 mr-3 "
                                    // style={{ fontSize: "1.5rem" }}

                                    disabled={!isEditing}
                                    checked={isSellAfterBuy}
                                    onChange={(e) => {
                                      setSellAfterBuy(e.target.checked);
                                    }}
                                  />
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                        {strategy !== "BINANCE-ARB" &&
                          strategy !== "KUCOIN-ARB" && (
                            <div className="form-group row">
                              <div className="col-12 border border-black rounded-lg pt-4 componentWrapper">
                                <div className="header">StopLoss Settings</div>

                                <div className="form-group row">
                                  <label
                                    className="col-sm-5 col-form-label"
                                    htmlFor="setStopLoss"
                                  >
                                    Set StopLoss{" "}
                                  </label>
                                  <div className="col-sm-6 form-check p-2 pr-3 mr-3 text-left">
                                    <input
                                      disabled={!isEditing}
                                      type="checkbox"
                                      className="pr-3 mr-3 "
                                      // style={{ fontSize: "1.5rem" }}
                                      id="setStopLoss"
                                      checked={isStopLossSet}
                                      onChange={(e) => {
                                        setIsStopLossSet(e.target.checked);
                                      }}
                                    />
                                  </div>
                                </div>

                                {isStopLossSet && (
                                  <div className="form-group row">
                                    <label className=" offset-1 col-sm-4 col-form-label">
                                      StopLoss (%){" "}
                                    </label>
                                    <div className="col-6">
                                      <input
                                        required={isStopLossSet}
                                        disabled={!isEditing}
                                        onChange={(e) => {
                                          setStopLoss(e.target.value);
                                        }}
                                        type="number"
                                        step="0.0001"
                                        className="form-control"
                                        min="0"
                                        value={stopLoss}
                                      />
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          )}
                        {strategy !== "BINANCE-ARB" &&
                          strategy !== "KUCOIN-ARB" &&
                          strategy !== "MARKET-MAKER" &&
                          strategy !== "MARKET-MAKER-RSI" &&
                          strategy !== "EMA-MA-CROSSOVER" && (
                            <div className="form-group row">
                              <div className="col-12 border border-black rounded-lg pt-4 componentWrapper">
                                <div className="header">
                                  Extra Orders Settings
                                </div>
                                <div className="form-group row mt-3 ">
                                  <label className="col-sm-5 col-form-label">
                                    Type
                                  </label>
                                  <div className="col-sm-6">
                                    <select
                                      required
                                      onChange={(e) => {
                                        setDcaOrGrid(e.target.value);
                                      }}
                                      disabled={bot.isRunning || !isEditing}
                                      className="custom-select mr-sm-2"
                                      defaultValue={dcaOrGrid}
                                    >
                                      <option value="DCA">DCA</option>
                                      <option value="GRID">Grid</option>
                                    </select>
                                  </div>
                                </div>
                                <div className="form-group row">
                                  <label className="col-sm-5 col-form-label">
                                    Max extra orders
                                  </label>
                                  <div className="col-6">
                                    <input
                                      disabled={!isEditing}
                                      required
                                      onChange={(e) => {
                                        setMaxExOrders(e.target.value);
                                      }}
                                      type="number"
                                      className="form-control"
                                      value={maxExtraOrders}
                                      min="0"
                                    />
                                  </div>
                                </div>
                                <div className="form-group row">
                                  <label className="col-sm-5 col-form-label">
                                    Active extra orders
                                  </label>
                                  <div className="col-6">
                                    <input
                                      disabled={!isEditing}
                                      required
                                      onChange={(e) => {
                                        setActiveExOrders(e.target.value);
                                      }}
                                      type="number"
                                      className="form-control"
                                      value={activeExtraOrders}
                                      min={
                                        parseFloat(maxExtraOrders) === 0
                                          ? "0"
                                          : "1"
                                      }
                                      max={maxExtraOrders.toString()}
                                    />
                                  </div>
                                </div>
                                <div className="form-group row">
                                  <label className="col-sm-5 col-form-label">
                                    Step of extra order (%)
                                  </label>
                                  <div className="col-6">
                                    <input
                                      disabled={!isEditing}
                                      required
                                      onChange={(e) => {
                                        setStepExOrder(e.target.value);
                                      }}
                                      type="number"
                                      step="0.0001"
                                      className="form-control"
                                      min="0.0001"
                                      value={stepOfExtraOrder}
                                    />
                                  </div>
                                </div>
                                <div className="form-group row">
                                  <label className="col-sm-5 col-form-label">
                                    Multiplier
                                  </label>
                                  <div className="col-6">
                                    <input
                                      disabled={
                                        !isEditing ||
                                        ((bot.version < 1 || !bot.version) &&
                                          bot.isRunning)
                                      }
                                      required
                                      onChange={(e) => {
                                        setMultiplier(e.target.value);
                                      }}
                                      type="number"
                                      step="0.0001"
                                      className="form-control"
                                      min="0.0001"
                                      value={multiplier}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        {strategy !== "BINANCE-ARB" &&
                          strategy !== "KUCOIN-ARB" &&
                          strategy !== "MARKET-MAKER" &&
                          strategy !== "MARKET-MAKER-RSI" && (
                            <div className="form-group row">
                              <label className="col-6 col-form-label">
                                Total Assets Need (
                                {type === "BUY"
                                  ? marketData.quoteAsset.toUpperCase()
                                  : marketData.baseAsset.toUpperCase()}
                                )
                              </label>
                              <div className="col-5">
                                <input
                                  disabled={true}
                                  type="number"
                                  className="form-control"
                                  value={getTotalCapital()}
                                />
                              </div>
                            </div>
                          )}
                        {isEditing && (
                          <div className="form-group row">
                            <div className="col-6 text-right">
                              <button
                                onClick={() => setIsEditing(false)}
                                className="btn btn-warning w-50 m-auto"
                                type="button"
                              >
                                Cancel
                              </button>
                            </div>
                            <div className="col-6 text-left">
                              <button
                                type="submit"
                                className="btn btn-primary w-50 m-auto"
                              >
                                Save
                              </button>
                            </div>
                          </div>
                        )}{" "}
                        {!isEditing && (
                          <div className="form-group row">
                            <div className="col-8 col-sm-6 text-center m-auto">
                              <button
                                type="button"
                                className="btn btn-primary w-75 m-auto"
                                onClick={() => {
                                  setEditing(true);
                                }}
                              >
                                Edit
                              </button>
                            </div>
                          </div>
                        )}
                      </form>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6 mt-3 overflow-hidden">
                  {bot !== null && (
                    <BotOrderDetails id={props.match.params.id} />
                  )}
                  <div className="row my-3 mx-1 ">
                    <div className="col-4 py-1  text-center  ">
                      <button
                        disabled={!bot.isRunning || bot.cancelPendingOrders}
                        onClick={() => {
                          cancelPendingOrders();
                        }}
                        type="button"
                        className="btn btn-warning btn-sm px-1 py-2 m-auto w-100 h-100 verticalCenter"
                      >
                        Cancel Pending Orders
                      </button>
                    </div>

                    <div className="col-4  py-1  text-center">
                      <button
                        disabled={!bot.isRunning || bot.cancelPendingOrders}
                        onClick={() => {
                          cancelPendingOrdersAndStop();
                        }}
                        type="button"
                        className="btn btn-danger btn-sm px-1 py-2 m-auto w-100 h-100 verticalCenter"
                      >
                        Cancel Pending Orders & Stop
                      </button>
                    </div>
                    <div className="col-4  py-1  text-center">
                      <button
                        disabled={
                          bot.stopAfterDealComplete ||
                          ((bot.version < 1 || !bot.version) &&
                            bot.isRunning) ||
                          !bot.isRunning
                        }
                        onClick={() => {
                          stopBotAfterDealComplete();
                        }}
                        type="button"
                        className="btn btn-danger btn-sm px-1 py-2 m-auto w-100 h-100 verticalCenter"
                      >
                        Stop After Deal Complete
                      </button>
                    </div>
                  </div>

                  <div className="row my-1 ">
                    <div className="col-4 p-1 text-center verticalCenter">
                      <Link
                        to="/account"
                        className="btn btn-secondary btn-sm px-1 py-2 m-auto w-75 verticalCenter"
                        style={{ borderRadius: "30px" }}
                      >
                        Back
                      </Link>
                    </div>
                    <div className="col-4  p-1 text-center">
                      {bot.isRunning ? (
                        <button
                          onClick={() => {
                            stopBot(true);
                          }}
                          type="button"
                          className="btn btn-danger w-75 m-auto"
                        >
                          Stop
                        </button>
                      ) : (
                        <button
                          onClick={() => {
                            startBot(true);
                          }}
                          type="button"
                          className="btn btn-success w-75 m-auto"
                          disabled={isRestricted}
                        >
                          Start
                        </button>
                      )}
                    </div>
                    <div className="col-4 p-1 text-center">
                      <button
                        disabled={isEditing}
                        type="button"
                        className="btn  btn-danger w-75 m-auto"
                        onClick={() => {
                          deleteBot(true);
                        }}
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="h4 my-5 py-5 mx-auto">Invalid Bot ID..</div>
      )}
    </div>
  );
}

export default withRouter(Bot);
